import { useEffect, useMemo, useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { LIMIT_PER_PAGE } from "./Constants";

const PaginatedDropdown = ({
  value,
  loadOptions,
  onChange = () => {},
  searchDelayMs = 300,
  placeholder = "Select an option...",
  isDisabled = false,
  isMulti = false,
  // Loading states
  loadingMessage = "Loading...",
  noOptionsMessage = "No options found",
  // Additional props
  ...restProps
}) => {
  const [selectedOption, setSelectedOption] = useState(value);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  // Handle selection change
  const handleChange = (newValue) => {
    setSelectedOption(newValue);
    onChange(newValue);
  };

  // Memoized styles
  const selectStyles = useMemo(
    () => ({
      container: (styles) => ({
        ...styles,
        zIndex: 2,
        width: "100%",
      }),
      control: (styles, { isDisabled, isFocused }) => ({
        ...styles,
        minHeight: 44,
        backgroundColor: isDisabled ? "#D2D6DB80" : "white",
        paddingLeft: "0.3rem",
        borderRadius: "0.375rem",
        borderColor: isFocused ? "#8b58f1" : "#CBCAD7",
        boxShadow: isFocused ? "0 0 0 1px #8b58f1" : undefined,
        ":hover": {
          borderColor: "#8b58f1",
        },
      }),
      option: (styles, { isDisabled, isSelected, isFocused }) => {
        return {
          ...styles,
          fontSize: "0.875rem",
          backgroundColor: isDisabled
            ? undefined
            : isSelected
            ? "#8b58f1"
            : isFocused
            ? "#8b58f11a"
            : undefined,
          ":active": {
            ...styles[":active"],
            backgroundColor: "#8b58f11a",
          },
        };
      },
      loadingMessage: (provided) => ({
        ...provided,
        color: "#6B7280",
      }),
      noOptionsMessage: (provided) => ({
        ...provided,
        color: "#6B7280",
      }),
    }),
    []
  );

  return (
    <AsyncPaginate
      value={selectedOption}
      onChange={handleChange}
      loadOptions={loadOptions}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isMulti={isMulti}
      debounceTimeout={searchDelayMs}
      styles={selectStyles}
      loadingMessage={() => loadingMessage}
      noOptionsMessage={() => noOptionsMessage}
      additional={{
        page: 1,
        limit: LIMIT_PER_PAGE,
      }}
      menuPlacement="auto"
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#8b58f1",
          primary75: "#8b58f1",
          primary50: "#8b58f11a",
          primary25: "#8b58f11a",
        },
      })}
      {...restProps}
    />
  );
};

export default PaginatedDropdown;
